webpackJsonp([216929306842663],{

/***/ 252:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(252);
	
	var _Image = __webpack_require__(17);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Opener = function Opener(_ref) {
	  var openerImage = _ref.openerImage;
	  return _react2.default.createElement(
	    'div',
	    { className: 'opener' },
	    _react2.default.createElement(
	      'div',
	      { className: 'large' },
	      _react2.default.createElement(
	        'p',
	        { className: 'right' },
	        'Liability limited by a scheme approved under Professional Standards Legislation.'
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    ),
	    _react2.default.createElement('div', { className: 'overlay' }),
	    _react2.default.createElement(_Image2.default, { className: 'cover', src: openerImage, alt: '' }),
	    _react2.default.createElement('div', { className: 'clear' })
	  );
	};
	
	exports.default = Opener;
	module.exports = exports['default'];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HomePageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Opener = __webpack_require__(176);
	
	var _Opener2 = _interopRequireDefault(_Opener);
	
	var _Hero = __webpack_require__(37);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _LargeTitle = __webpack_require__(38);
	
	var _LargeTitle2 = _interopRequireDefault(_LargeTitle);
	
	var _Column = __webpack_require__(14);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Image = __webpack_require__(17);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomePageTemplate = exports.HomePageTemplate = function HomePageTemplate(_ref) {
	  var title = _ref.title,
	      openerImage = _ref.openerImage,
	      about = _ref.about,
	      areas = _ref.areas,
	      footerImage = _ref.footerImage,
	      meta = _ref.meta;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta.description })
	    ),
	    _react2.default.createElement(_Opener2.default, { openerImage: openerImage }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_LargeTitle2.default, {
	        smallTitle: about.subtitle,
	        title: about.title,
	        largeTitle: about.largeTitle
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'small content' },
	        _react2.default.createElement(
	          _Column2.default,
	          { left: true },
	          _react2.default.createElement(_Content2.default, { src: about.leftColumn })
	        ),
	        _react2.default.createElement(
	          _Column2.default,
	          { right: true },
	          _react2.default.createElement(_Content2.default, { src: about.rightColumn })
	        ),
	        _react2.default.createElement('div', { className: 'clear' })
	      ),
	      _react2.default.createElement(_Button2.default, { text: 'discover more', page: '/areas/' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_LargeTitle2.default, {
	        smallTitle: areas.subtitle,
	        title: areas.title,
	        largeTitle: areas.largeTitle
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'small content' },
	        _react2.default.createElement(
	          _Column2.default,
	          { left: true },
	          _react2.default.createElement(_Content2.default, { src: areas.leftColumn })
	        ),
	        _react2.default.createElement(
	          _Column2.default,
	          { right: true },
	          _react2.default.createElement(_Content2.default, { src: areas.rightColumn })
	        ),
	        _react2.default.createElement('div', { className: 'clear' })
	      ),
	      _react2.default.createElement(_Button2.default, { text: 'discover more', page: '/about/' })
	    ),
	    _react2.default.createElement(_Hero2.default, { image: footerImage, footer: true })
	  );
	};
	
	var HomePage = function HomePage(_ref2) {
	  var page = _ref2.data.page;
	  return _react2.default.createElement(HomePageTemplate, _extends({}, page, page.frontmatter, { body: page.html }));
	};
	
	exports.default = HomePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-page-js-6a2c136ca2227ebaac51.js